import { Button, buttonVariants } from '@labflow/ui';
import { useQueryClient } from '@tanstack/react-query';
import type { ErrorComponentProps } from '@tanstack/react-router';

import { StatusScreen } from './status-screen';

/**
 * 렌더 중 잡히지 않은 예외의 안전망. 원본 오류 메시지는 화면에 내지 않는다(콘솔은 루트 `onCatch`).
 * 라우터 기본값으로는 각 라우트의 `Outlet` 자리에서 렌더돼 헤더가 남는다. 루트 레이아웃이 깨지면 루트 경계가 쓴다.
 */
export function RouteErrorFallback({ reset }: ErrorComponentProps) {
  const queryClient = useQueryClient();

  function retry() {
    void queryClient.invalidateQueries();
    reset();
  }

  return (
    <StatusScreen
      title="화면을 열지 못했어요"
      actions={
        <>
          <Button onClick={retry}>다시 시도</Button>
          {/* 루트 레이아웃까지 깨졌을 때도 동작하도록 전체 새로 고침으로 간다 */}
          <a href="/" className={buttonVariants({ variant: 'outline' })}>
            홈으로 가기
          </a>
        </>
      }
    />
  );
}
